module.exports = __webpack_public_path__ + "img/detail.571c36e3.png";